import React from 'react'

const Index = () => {
  return (
    <div>This is Registration Page</div>
  )
}

export default Index